import React from 'react';
import './TrustScore.css';

function TrustScore() {
  return (
    <div className="page-container">
      <div className="header-section">
        <h1>Trust Score</h1>
        <p className="lead">Comprehensive trust assessment and scoring system</p>
      </div>

      <div className="content-section">
        <div className="row">
          <div className="col-md-4">
            <div className="score-card">
              <div className="score-header">Overall Trust Score</div>
              <div className="score-value">85</div>
              <div className="score-trend positive">
                <i className="bi bi-arrow-up"></i>
                <span>+5 points this month</span>
              </div>
            </div>
          </div>

          <div className="col-md-8">
            <div className="card mb-4">
              <div className="card-body">
                <h3>Score Breakdown</h3>
                <div className="score-breakdown">
                  <div className="score-item">
                    <div className="score-label">Data Protection</div>
                    <div className="progress">
                      <div 
                        className="progress-bar bg-success" 
                        role="progressbar" 
                        style={{width: '90%'}} 
                        aria-valuenow="90" 
                        aria-valuemin="0" 
                        aria-valuemax="100"
                      >90%</div>
                    </div>
                  </div>
                  <div className="score-item">
                    <div className="score-label">Transparency</div>
                    <div className="progress">
                      <div 
                        className="progress-bar bg-info" 
                        role="progressbar" 
                        style={{width: '85%'}} 
                        aria-valuenow="85" 
                        aria-valuemin="0" 
                        aria-valuemax="100"
                      >85%</div>
                    </div>
                  </div>
                  <div className="score-item">
                    <div className="score-label">Compliance</div>
                    <div className="progress">
                      <div 
                        className="progress-bar bg-warning" 
                        role="progressbar" 
                        style={{width: '75%'}} 
                        aria-valuenow="75" 
                        aria-valuemin="0" 
                        aria-valuemax="100"
                      >75%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                <h3>Recommendations</h3>
                <ul className="recommendation-list">
                  <li className="recommendation-item">
                    <i className="bi bi-check-circle text-success"></i>
                    <span>Update privacy policy documentation</span>
                  </li>
                  <li className="recommendation-item">
                    <i className="bi bi-exclamation-circle text-warning"></i>
                    <span>Enhance data encryption protocols</span>
                  </li>
                  <li className="recommendation-item">
                    <i className="bi bi-info-circle text-info"></i>
                    <span>Review third-party integrations</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrustScore;
